var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQurix(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: "1000px",
    height: "310px",
    viewBox: "45 412 1024 310",
    enableBackground: "new 0 0 1024 1024",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    fill: "#18BBD3",
    d: "M149.972,414.052c-55.22,0-100,44.77-100,100s44.78,100,100,100c55.23,0,100-44.77,100-100 S205.202,414.052,149.972,414.052z M149.972,564.052c-27.61,0-50-22.38-50-50c0-27.61,22.39-50,50-50c27.62,0,50,22.39,50,50 C199.972,541.672,177.592,564.052,149.972,564.052z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    fill: "#18BBD3",
    d: "M249.972,690.052c0,13.255-10.745,24-24,24h-2c-13.255,0-24-10.745-24-24v-252 c0-13.255,10.745-24,24-24h2c13.255,0,24,10.745,24,24V690.052z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    fill: "#18BBD3",
    d: "M418.111,428.592c-1.25,2.9-1.94,6.1-1.94,9.46v76c0,27.62-22.39,50-50,50 c-27.62,0-50-22.38-50-50v-76c0-3.36-0.69-6.56-1.94-9.46c-28.82,17.54-48.06,49.25-48.06,85.46c0,36.21,19.24,67.92,48.06,85.46 c15.14,9.23,32.92,14.54,51.94,14.54c19.02,0,36.8-5.31,51.94-14.54c28.82-17.54,48.06-49.25,48.06-85.46 C466.171,477.842,446.931,446.132,418.111,428.592z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    fill: "#18BBD3",
    d: "M466.171,438.052v76c0,36.21-19.24,67.92-48.06,85.46c-1.25-2.91-1.94-6.1-1.94-9.46v-152 c0-3.36,0.69-6.56,1.94-9.46c3.67-8.56,12.16-14.54,22.06-14.54h2C455.421,414.052,466.171,424.792,466.171,438.052z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    fill: "#18BBD3",
    d: "M316.171,438.052v152c0,3.36-0.69,6.55-1.94,9.46c-28.82-17.54-48.06-49.25-48.06-85.46v-76 c0-13.26,10.74-24,24-24h2c9.89,0,18.39,5.98,22.06,14.54C315.481,431.492,316.171,434.692,316.171,438.052z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    fill: "#18BBD3",
    d: "M637.031,427.502l-1.47-0.85c-14.39-8.03-30.97-12.6-48.62-12.6 c-18.23,0-35.31,4.87-50.02,13.39c-0.65,0.37-1.29,0.75-1.93,1.14c-28.81,17.55-48.05,49.26-48.05,85.47 c0,36.21,19.24,67.92,48.05,85.47c1.26-2.91,1.95-6.11,1.95-9.47v-76c0-27.61,22.39-50,50-50c8.94,0,17.34,2.35,24.6,6.46 l0.49,0.29c0.04,0.02,0.08,0.05,0.12,0.07c11.45,6.53,26.05,2.58,32.66-8.86l1-1.73 C652.441,448.802,648.501,434.122,637.031,427.502z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    fill: "#18BBD3",
    d: "M536.941,438.052v152c0,3.36-0.69,6.56-1.95,9.47c-3.67,8.54-12.16,14.53-22.05,14.53h-2 c-13.25,0-24-10.75-24-24v-152c0-13.26,10.75-24,24-24h2c1.49,0,2.96,0.14,4.37,0.41c6.74,1.23,12.49,5.28,15.99,10.89 c0.65,1.03,1.21,2.1,1.69,3.23C536.251,431.482,536.941,434.682,536.941,438.052z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    fill: "#18BBD3",
    d: "M645.811,460.282l-1,1.73c-6.61,11.44-21.21,15.39-32.66,8.86 c-0.04-0.02-0.08-0.05-0.12-0.07l-0.49-0.29l-74.62-43.07c14.71-8.52,31.79-13.39,50.02-13.39c17.65,0,34.23,4.57,48.62,12.6 l1.47,0.85C648.501,434.122,652.441,448.802,645.811,460.282z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    fill: "#18BBD3",
    d: "M891.643,421.082c9.373-9.373,24.569-9.373,33.941,0l1.414,1.414 c9.373,9.373,9.373,24.569,0,33.941L776.385,607.051c-9.373,9.373-24.569,9.373-33.941,0l-1.414-1.414 c-9.373-9.373-9.373-24.569,0-33.941L891.643,421.082z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    fill: "#18BBD3",
    d: "M781.029,456.437c-9.373-9.373-9.373-24.569,0-33.941l1.414-1.414 c9.373-9.373,24.569-9.373,33.941,0l150.614,150.614c9.373,9.373,9.373,24.569,0,33.941l-1.414,1.414 c-9.373,9.373-24.569,9.373-33.941,0L781.029,456.437z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    fill: "#18BBD3",
    d: "M720.536,590.052c0,13.255-10.745,24-24,24h-2c-13.255,0-24-10.745-24-24v-152 c0-13.255,10.745-24,24-24h2c13.255,0,24,10.745,24,24V590.052z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    fill: "#18BBD3",
    d: "M720.536,560.052c0,13.255-10.745,24-24,24h-2c-13.255,0-24-10.745-24-24v-32 c0-13.255,10.745-24,24-24h2c13.255,0,24,10.745,24,24V560.052z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQurix);
export default __webpack_public_path__ + "static/media/qurix.250b31b08ab036c58d9d5d4d3a600794.svg";
export { ForwardRef as ReactComponent };